import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  withStyles,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import BuzzLabel from '../BuzzLabel/BuzzLabel';
import BuzzInput from '../BuzzInput/BuzzInput';

export default function BuzzMapInput({ id, label, value, onChange, required }) {
  const [state, setState] = useState({ ...value, '': '' });

  useEffect(() => {
    const payload = { ...state };
    payload[''] = undefined;

    onChange(payload);
  }, [state]);

  return (
    <Box>
      <BuzzLabel label={label} required={required} id={id} />
      {Object.entries(state).map(([key, value]) => {
        return (
          <Box display={'flex'} style={{ gap: '1rem' }}>
            <BuzzInput
              type="text"
              // label={formField.title}
              value={key}
              placeholder={'key'}
              onChange={(e) => {
                setState((state) => ({
                  ...state,
                  [key]: undefined,
                  [e.target.value]: value,
                }));
                // let newValue = e.target.value;
                // if (formField.onChange) newValue = formField.onChange(newValue);
                // setFormData(formField.slug, newValue);
              }}
            />
            <BuzzInput
              type="text"
              // label={formField.title}
              value={value}
              placeholder={'value'}
              onChange={(e) => {
                setState((state) => ({ ...state, [key]: e.target.value }));
                // let newValue = e.target.value;
                // if (formField.onChange) newValue = formField.onChange(newValue);
                // setFormData(formField.slug, newValue);
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
}
